import { setLanguage, withCurrentLanguage } from '@wheelbox/lithejs-i18n';
import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

import { createId } from '../../../../utils';

type LanguageSwitcherProps = {
  languages: string[];
};

const LanguageSwitcher: LitheFC<LanguageSwitcherProps> = ({
  id = createId(),
  testId = 'language-switcher',
  languages,
}): LitheElement<'ul'> => {
  const handleLanguageSwitch = (lng: string) => {
    setLanguage(lng);
  };

  return [
    'ul',
    {
      id,
      'data-testid': testId,
      class: 'list-none ps-0 flex gap-4 items-center',
    },
    ...languages.map<LitheElement<'li'>>((lng) => [
      'li',
      {
        class: [
          'cursor-pointer border-b-3 border-transparent hover:text-primary focus:outline-2 focus:outline-primary focus:outline-offset-2',
          lng === withCurrentLanguage() ? 'border-primary' : '',
        ],
        tabindex: '0',
        onclick: () => handleLanguageSwitch(lng),
      },
      lng.toUpperCase(),
    ]),
  ];
};

export default LanguageSwitcher;
